import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Hash } from "lucide-react";
import { errText, fetchSeries, moveSeries } from "@/lib/bf";

export default function BFContractSeries() {
  const [x, setX] = useState(null);
  const load = () => fetchSeries().then(setX).catch(() => setX({ series: [], agents: [] }));
  useEffect(() => { load(); }, []);
  const move = (code, agent) => moveSeries(code, agent).then(() => { toast.success(`Seria ${code} a fost mutată`); load(); }).catch((e) => toast.error(errText(e, "Nu am putut muta seria")));
  return (
    <section className="invite-box" data-testid="bf-contract-series">
      <h3><Hash size={18} /> Serii numere contract</h3>
      <p className="st-hint">Fiecare agent are seria lui (ex. S03-0007/2026), fără legătură cu numele. Numărul se alocă clientului la prima semnare și rămâne al lui. Dacă schimbi agentul, mută seria la noul agent și numerotarea continuă.</p>
      <ul className="bfa-leads">
        {(x?.series || []).map((s) => (
          <li key={s.code} data-testid={`bf-series-${s.code}`}>
            <div><b>{s.code}</b><span>{s.agent_name} · ultimul număr: {s.seq ? `${s.code}-${String(s.seq).padStart(4, "0")}` : "niciun contract încă"}</span></div>
            <select value={s.agent} onChange={(e) => move(s.code, e.target.value)} data-testid={`bf-series-agent-${s.code}`}>
              {!x.agents.some((a) => a.slug === s.agent) && <option value={s.agent}>{s.agent_name}</option>}
              {x.agents.map((a) => <option key={a.slug} value={a.slug}>{a.name}</option>)}
            </select>
          </li>
        ))}
      </ul>
    </section>
  );
}
